export default "__VITE_ASSET__1e550b89__"